import { useEffect } from "react";
import { navigate } from "@reach/router";

export default function ShareProfileRedirect({ location }) {
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const sc = params.get("sc");
		const sharedCompanyId = params.get("company");

		if (sc) {
			localStorage.setItem("ST", sc);
			localStorage.setItem("SharedCompanyId", sharedCompanyId);
			navigate(`/login?sc=${sc}`, { replace: true });
		} else {
			navigate("/login", { replace: true });
		}
	}, [location.search]);

	return null;
}
